import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import OptimizationDetailsSection from 'src/components/OptimizationDetailsSection';
import UptimeSplash from 'src/components/UptimeSplash';

import ImgIphoneUnitCostZones from 'src/images/img-iphone-unit-cost-zones.png';
import ImgIphoneUnitCostZones2x from 'src/images/img-iphone-unit-cost-zones@2x.png';
import ImgIphoneUnitCostZones3x from 'src/images/img-iphone-unit-cost-zones@3x.png';
import IconOptimization from 'src/images/icon-optimization.png';
import IconOptimization2x from 'src/images/icon-optimization@2x.png';
import IconOptimization3x from 'src/images/icon-optimization@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconOptimization, IconOptimization2x, IconOptimization3x]} />
              <div className='h1 mt-2'>Optimization</div>
              <div className='h2 text-blue'>Tune your shipping engine.</div>
              <div styleName='message'>
                  Opaque pricing schemes, complex optimization problems, and a
                  shifting landscape of carriers and services &mdash; shipping is
                  a hard game to win. Optimization levels the playing field.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgIphoneUnitCostZones, ImgIphoneUnitCostZones2x, ImgIphoneUnitCostZones3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <OptimizationDetailsSection />
      <UptimeSplash />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/optimization.js